import { BaseCanvas } from "@visactor/vrender-core";

import { HarmonyContext2d } from "./context";

export class HarmonyCanvas extends BaseCanvas {
    constructor(params) {
        super(params);
    }
    init() {
        this._context = new HarmonyContext2d(this, this._dpr);
    }
    resize(width, height) {
        this.controled && (this._pixelWidth = width * this._dpr, this._pixelHeight = height * this._dpr, 
        this._displayWidth = width, this._displayHeight = height, this._nativeCanvas.width = this._pixelWidth, 
        this._nativeCanvas.height = this._pixelHeight, this._context.dpr = this._dpr);
    }
    release(...params) {}
}

HarmonyCanvas.env = "harmony";
//# sourceMappingURL=canvas.js.map
